<template>
  <b-card class="m-2 black-box-secondary bg-rose">
    <b-card-text>
      <b-row>
        <b-col md="8">
          <span style="font-weight: 600">{{ nomeTipo }}</span>
        </b-col>
        <b-col md="4" class="bottoni">
          <div class="rounded-pill bg-white text-center p-2" style="text-transform: uppercase">
            {{ item.src_language.id }} <span class="flag">{{ item.src_language.flag }}</span>
            <b-icon icon="chevron-right" font-scale="1" class="mx-2"></b-icon>
            {{ item.dest_language.id }} <span class="flag">{{ item.dest_language.flag }}</span>
            <b-icon-music-note
              v-if="item.request_audio"
              title="E' richiesta anche la lettura audio"
              v-b-tooltip.hover
            ></b-icon-music-note>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8">
          <a @click="showNote(item.note)" class="text-primary" v-if="item.note" href="#"> Note </a><br />
          Richiesta da: {{ item.requester.first_name }} {{ item.requester.last_name }} <br />
          Consegna: <span v-if="item.due_date">{{ item.due_date | moment("DD/MM/YYYY") }}</span>
          <span v-if="!item.due_date" class="text-muted">non specificata</span>
        </b-col>
        <b-col md="4" class="text-right bottoni">
          <br />
          <b-button
            pill
            @click.prevent="download(`${item.id}/original/${item.name}`)"
            variant="outline-primary"
            class="btn-circle"
            :href="`${item.id}/original/${item.name}`"
            v-b-tooltip.hover
            title="Scarica Documento Originale"
          >
            <b-icon-file-earmark></b-icon-file-earmark>
          </b-button>
          &nbsp;

          <b-button
            pill
            @click.prevent="download(`${item.id}/reviewed/${item.name}`)"
            variant="outline-warning"
            class="btn-circle"
            v-if="item.delivery_date"
            :href="`${item.id}/reviewed/${item.name}`"
            v-b-tooltip.hover
            title="Scarica Documento Tradotto"
          >
            <b-icon-file-earmark-check></b-icon-file-earmark-check>
          </b-button>
          &nbsp;
          <b-button
            pill
            @click.prevent="download(`${item.id}/audio/${item.name}`)"
            variant="outline-success"
            v-if="item.delivery_date && isAudio"
            class="btn-circle"
            title="Scarica Traduzione Audio"
            v-b-tooltip.hover
          >
            <b-icon-music-note></b-icon-music-note>
          </b-button>
        </b-col>
      </b-row>
    </b-card-text>
  </b-card>
</template>

<script>
import "vue2-datepicker/locale/it";
import myMixing from "@/mixing/util";

export default {
  name: "CardOrg2",
  mixins: [myMixing],
  props: ["item"],
  data() {
    return {};
  },
  computed: {
    isAudio: function () {
      return this.item.audio_exists;
    },
  },
};
</script>
<style>
.bg-rose {
  background-color: #ffdfe2 !important;
}
</style>
